import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/styles/index.scss";
import ElementPlus from "element-plus";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import "element-plus/dist/index.css";
import plugins from "./plugins";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import store from "./store";
import "./rem";
// 分页组件
import Pagination from "@/components/Pagination";
import * as echarts from "echarts";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import "./permission"; // permission control

const app = createApp(App);

// 引入生成器组件
import generators from "@/components/Generators";
generators.forEach((item) => {
  app.component(item.comName, item.com);
});
// 全局方法挂载
app.config.globalProperties.$echarts = echarts;
app.component("Pagination", Pagination);
app.use(ElementPlus, {
  locale: zhCn,
});
// 2. 全局注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.use(router);
app.use(store);
app.use(plugins);
app.mount("#app");
